import { Modal } from "react-bootstrap";

const plural = (n, one, many) => (n === 1 ? `1 ${one}` : `${n} ${many}`);

/**
 * "You have unsaved changes" (MG-003.1): shown when the user collapses an auction, or leaves the
 * page, while Team Buyback changes are unsaved. Closing it by Escape or the backdrop is Keep editing.
 *
 * @param {{ show: boolean, teams: number, auctions: number, saving: boolean,
 *           onDiscard: Function, onKeep: Function, onSave: Function }} props
 *   teams / auctions: what is unsaved - one auction when collapsing, every changed one when leaving.
 */
export const UnsavedChangesModal = ({ show, teams, auctions, saving, onDiscard, onKeep, onSave }) => (
  <Modal
    show={show}
    onHide={onKeep}
    centered
    dialogClassName="buyback-leave-dialog"
    aria-labelledby="buyback-leave-title"
    backdrop={saving ? "static" : true}
    keyboard={!saving}
  >
    <Modal.Header>
      <Modal.Title id="buyback-leave-title">You have unsaved changes</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      You changed Team Buyback for {plural(teams, "team", "teams")}{" "}
      {auctions > 1 ? `in ${auctions} auctions` : "in this auction"}. Save the changes before you leave, or discard
      them.
    </Modal.Body>
    <Modal.Footer>
      <button type="button" className="buyback-btn buyback-btn-link" onClick={onDiscard} disabled={saving}>
        Discard changes
      </button>
      <button type="button" className="buyback-btn buyback-btn-outline" onClick={onKeep} disabled={saving}>
        Keep editing
      </button>
      <button type="button" className="buyback-btn buyback-btn-primary" onClick={onSave} disabled={saving}>
        {saving ? "Saving..." : "Save changes"}
      </button>
    </Modal.Footer>
  </Modal>
);
